import findPlanByLegacyId from 'utils/pivot/plan/findPlanByLegacyId'
import findPlanById from 'utils/pivot/plan/findPlanById'
import isNumber from 'utils/number/isNumber'

function getPlanByPlanId({ id, planList, plans, period }) {
  return isNumber(+id)
    ? findPlanById(planList, +id, plans, period)
    : findPlanByLegacyId(planList, plans, id)
}

export default getPlanByPlanId
